import { MegaFilterLabelOption } from 'interfaces/labels/MegaFilterLabelOption'

export const getLabelUniqueIdentifier = (label: MegaFilterLabelOption): string => {
  if (label.isDerived) return `${label.code}-${label.value}`
  return label.code
}
